// extracted by mini-css-extract-plugin
export default {"headerImage":"Subject_headerImage__LJ8zq","headerInfo":"Subject_headerInfo__LwgW2"};